export default __webpack_public_path__ + "static/launch-partner_misang_right@2x-41890324e4438b9b6cfee070ecd0fc1f.jpg";